export default __webpack_public_path__ + "static/B0085-aa84229171b357073f8c20ea482b972a.png";